import React from 'react';
import type { IconComponentProps } from '@/types/components';

export const MailCircle: React.FC<IconComponentProps> = ({ className }) => (
  <svg
    className={className}
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="16" cy="16" r="16" fill="#8A82E7" />
    <g clipPath="url(#mail-circle-clip)">
      <path
        d="M22.5335 11.1583C22.3168 11.0583 22.0835 11 21.8335 11H10.1668C9.9168 11 9.68346 11.0583 9.4668 11.1583L16.0001 16.875L22.5335 11.1583Z"
        className="fill-card"
      />
      <path
        d="M23.275 11.8398L16.3333 17.9148C16.2417 17.9982 16.125 18.0398 16 18.0398C15.875 18.0398 15.7667 17.9982 15.6667 17.9148L8.725 11.8398C8.58333 12.0815 8.5 12.3648 8.5 12.6648V19.3315C8.5 20.2482 9.25 20.9982 10.1667 20.9982H21.8333C22.75 20.9982 23.5 20.2482 23.5 19.3315V12.6648C23.5 12.3648 23.4167 12.0815 23.275 11.8398Z"
        className="fill-card"
      />
    </g>
    <defs>
      <clipPath id="mail-circle-clip">
        <rect
          width="15"
          height="10"
          className="fill-card"
          transform="translate(8.5 11)"
        />
      </clipPath>
    </defs>
  </svg>
);
